import { useEffect, useRef } from 'react';
import { useGamificationStore } from '../../../stores/gamification-store.js';
import { useProfile } from './useGamification.js';

/**
 * Detecta subidas de nivel comparando `profile.level` contra el valor previo.
 * La carga inicial no dispara el modal — solo un aumento posterior (el XP se
 * otorga async en el backend, así que el cambio llega vía refetch).
 */
export function useLevelUpWatcher() {
  const { data: profile } = useProfile();
  const showLevelUp = useGamificationStore((s) => s.showLevelUp);
  const prevLevelRef = useRef<number | null>(null);

  useEffect(() => {
    const level = profile?.level;
    if (level === undefined) return;
    const prev = prevLevelRef.current;
    prevLevelRef.current = level;
    if (prev !== null && level > prev) {
      showLevelUp(level);
    }
  }, [profile?.level, showLevelUp]);
}
